<template>
  <a-modal v-model="visible" title="插入模板-节头1" @ok="handleOk">
    <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="节序号">
        <a-input v-model="lesson.serialName"/>
      </a-form-model-item>
      <a-form-model-item label="节名称">
        <a-input v-model="lesson.title"/>
      </a-form-model-item>
  </a-form-model>
</a-modal>
</template>

<script>
export default {
  name: 'UnitHeader1',
  data() {
    return {
      visible: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      lesson: {
        serialName: undefined,
        title: undefined
      }
    }
  },
  methods: {
    open() {
      this.visible = true
    },
    handleOk() {
      let content = `<div class="mceNonEditable fm_lesson_simple">
          <div class="serial_name">${this.lesson.serialName}</div>
          <div class="title">${this.lesson.title}</div>
        </div>`
      this.$emit('ok', {content: content})
      this.visible = false
    }
  }
}
</script>

<style>

</style>